/**
 * Has generation just FINISHED — as opposed to merely being finished already?
 *
 * The success capture (elapsed time, success animation, clearing the start
 * time) must fire exactly once, on the generating -> generated edge. Testing
 * `isGenerated` alone is not that edge: a flight keeps `generation_status =
 * 'generated'` after a successful run, so the flag is still true when the
 * admin clicks Generate AGAIN on the same flight.
 *
 * That is a real bug, not a hypothetical: re-generating flight 609 (which
 * ends `generated`) started the clock on click and the success effect then
 * immediately cleared it, leaving "0:00 elapsed" frozen for the whole request.
 *
 * `isGenerating` is what separates the two: during a re-generate it is true
 * from the click, so the previous run's `generated` status can no longer be
 * mistaken for this run's completion. Extracted so the rule is pinned by
 * tests rather than by an effect's dependency array — the original defect was
 * caused by editing exactly such a list.
 */
export const isGenerationSuccessTransition = ({
  isGenerated,
  isGenerating,
  wasGenerating,
}: {
  isGenerated: boolean
  isGenerating: boolean
  wasGenerating: boolean
}): boolean => isGenerated && !isGenerating && wasGenerating
